export const ui = {
  state: {
    onboarding: false,
    invalidToken: false,
    showSettings: [],
    errorMessage: null,
    loadingMessage: null,
    clientControllerType: null
  },
  mutations: {
    showError (state, { message }) {
      state.errorMessage = message
    },
    hideError (state) {
      state.errorMessage = null
    },
    showLoading (state, { message }) {
      state.loadingMessage = message
    },
    hideLoading (state) {
      state.loadingMessage = null
    },
    pushSettings (state, screen) {
      state.showSettings.push(screen)
    },
    popSettings (state) {
      state.showSettings.pop()
    },
    onboarding (state, screen) {
      state.onboarding = screen
    },
    receivedClientControllerType (state, controllerType) {
      state.clientControllerType = controllerType
    },
    invalidToken (state, value) {
      state.invalidToken = value
    }
  },
  actions: {
    hideLoading ({ commit }) {
      commit('hideLoading')
    },
    showLoading ({ commit }, { message }) {
      commit('showLoading', { message })
    },
    showError ({ commit }, { message }) {
      commit('showError', { message })
    },
    hideError ({ commit }) {
      commit('hideError')
    },
    goBackInSettings ({ commit }) {
      commit('popSettings')
    },
    showSettingsMenu ({ commit }) {
      commit('pushSettings', 'menu')
    },
    showLanguageSettings ({ commit }) {
      commit('pushSettings', 'languages')
    },
    showTranslationModeSettings ({ commit }) {
      commit('pushSettings', 'translationMode')
    },
    showPermissionSettings ({ commit }) {
      commit('pushSettings', 'permissions')
    },
    showPreTranslationSettings ({ commit }) {
      commit('pushSettings', 'preTranslation')
    },
    showAccountSettings ({ commit }) {
      commit('pushSettings', 'account')
    },
    showUnbabelAccount ({ commit }) {
      commit('pushSettings', 'unbabelAccount')
    },
    showTicketAccess ({ commit }) {
      commit('pushSettings', 'ticketAccess')
    },
    showOnboardingScreen ({ commit }) {
      commit('showOnboarding', 'initial')
    },
    setClientControllerType ({ commit }, controllerType) {
      commit('receivedClientControllerType', controllerType)
    },
    invalidToken ({ commit }, value) {
      commit('invalidToken', value)
    },
    async globalInitializer ({ state: { clientControllerType }, commit, dispatch }) {
      dispatch('showLoading', { message: `Fetching data from Unbabel` })
      try {
        await dispatch('initializeMessages')
        commit('onboarding', false)
        commit('invalidToken', false)
        dispatch('hideLoading')
      } catch (err) {
        switch (err.status) {
          case 401:
            dispatch('invalidToken', true)
            break
          case 403:
          case 404:
            commit('onboarding', true)
            break
        }
        dispatch('hideLoading')
        console.error(err)
      }
      // dispatch('poolTranslations')
    }
  },
  getters: {
    hasError: (state) => state.errorMessage !== null,
    isLoading: (state) => state.loadingMessage !== null,
    onboarding: ({ onboarding }) => onboarding,

    errorMessage: (state) => state.errorMessage,
    invalidToken: ({ invalidToken }) => invalidToken,
    loadingMessage: (state) => state.loadingMessage,

    showSettings: ({ showSettings }) => showSettings,
    showingSettings: ({ showSettings }) => showSettings.length > 0,
    settingsPane: ({ showSettings }) => showSettings[showSettings.length - 1]
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/ui.js